module.exports = __webpack_public_path__ + "img/mickey134.804d1a45.jpg";